
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Filter, ArrowDown, ArrowUp } from "lucide-react";

interface SortControlsProps {
  sortField: "name" | "firmName" | "relevance";
  sortDirection: "asc" | "desc";
  handleSortChange: (field: "name" | "firmName" | "relevance") => void;
}

const SortControls = ({ 
  sortField, 
  sortDirection, 
  handleSortChange 
}: SortControlsProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-10">
          <Filter className="h-4 w-4 mr-2" />
          Filter & Sort
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-4">
        <div className="space-y-2">
          <h4 className="font-medium text-sm">Sort by</h4>
          <div className="flex flex-col space-y-1">
            <Button 
              variant={sortField === "name" ? "default" : "outline"} 
              size="sm"
              onClick={() => handleSortChange("name")}
              className="justify-start"
            >
              Name
              {sortField === "name" && (
                sortDirection === "asc" ? 
                <ArrowUp className="ml-2 h-4 w-4" /> : 
                <ArrowDown className="ml-2 h-4 w-4" />
              )}
            </Button>
            <Button 
              variant={sortField === "firmName" ? "default" : "outline"} 
              size="sm"
              onClick={() => handleSortChange("firmName")}
              className="justify-start"
            >
              Fund
              {sortField === "firmName" && (
                sortDirection === "asc" ? 
                <ArrowUp className="ml-2 h-4 w-4" /> : 
                <ArrowDown className="ml-2 h-4 w-4" />
              )}
            </Button>
            <Button 
              variant={sortField === "relevance" ? "default" : "outline"} 
              size="sm"
              onClick={() => handleSortChange("relevance")}
              className="justify-start"
            >
              Relevance
              {sortField === "relevance" && (
                sortDirection === "asc" ? 
                <ArrowUp className="ml-2 h-4 w-4" /> : 
                <ArrowDown className="ml-2 h-4 w-4" />
              )}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SortControls;
